import { __assign, __rest } from "tslib";
import React from 'react';
import { cn } from '../../utils/bem';
import { forwardRefWithAs } from '../../utils/types/PropsWithAsAttributes';
import { Text } from '../Text/Text';
var cnFieldCaption = cn('FieldCaption');
export var FieldCaption = forwardRefWithAs(function (props, ref) {
    var status = props.status, children = props.children, className = props.className, otherProps = __rest(props, ["status", "children", "className"]);
    return (React.createElement(Text, __assign({ view: status || 'secondary', className: cnFieldCaption(null, [className]) }, otherProps, { ref: ref, size: "xs", lineHeight: "2xs" }), children));
});
